import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#D80027\" d=\"m1.457 6.26 10.541 1.044 10.54-1.044A12 12 0 0 0 11.999 0C7.449 0 3.492 2.53 1.457 6.26\"></path><path fill=\"#FFDA44\" d=\"M1.46 17.738 12 18.782l10.54-1.044C23.472 16.034 24 14.078 24 12l-12-1.043-12 1.043c0 2.08.529 4.034 1.46 5.74\"></path><path fill=\"#0052B4\" d=\"M1.46 6.261A11.95 11.95 0 0 0 0 12.001h24c0-2.08-.529-4.035-1.46-5.74H1.46\"></path><path fill=\"#6DA544\" d=\"M11.998 24c4.549 0 8.506-2.531 10.54-6.261H1.458a12 12 0 0 0 10.541 6.26\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }